const dateFormatter = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: 'long',
  year: 'numeric',
})

const shortDateFormatter = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
})

/** `2023-12-17` -> `17. Dezember 2023`. Returns '' for missing input. */
export function formatDate(iso) {
  if (!iso) return ''
  const date = new Date(`${iso}T12:00:00`)
  if (Number.isNaN(date.getTime())) return iso
  return dateFormatter.format(date)
}

/** `2023-12-17` -> `17.12.2023`. */
export function formatDateShort(iso) {
  if (!iso) return ''
  const date = new Date(`${iso}T12:00:00`)
  if (Number.isNaN(date.getTime())) return iso
  return shortDateFormatter.format(date)
}

/** Initials for the testimonial avatars: 'L. Weinberger' -> 'LW'. */
export function initials(name) {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join('')
}
